<!-- BREADCRUMB -->
<div id="breadcrumb" class="section">
  <!-- container -->
  <div class="container">
    <!-- row -->
    <div class="row">
      <div class="col-md-12">
        <ul class="breadcrumb-tree">
          <li><a routerLink="/">Home</a></li>
          <li>All Categories</li>
          <li><a routerLink="/product-category/{{getSlug(product?.category)}}">{{product?.category}}</a></li>
          <li class="active"><a routerLink="/product-category/{{getSlug(product?.category)}}/{{getSlug(product?.name)}}">{{product?.name}}</a></li>
        </ul>
      </div>
    </div>
    <!-- /row -->
  </div>
  <!-- /container -->
</div>
<!-- /BREADCRUMB -->

<!-- SECTION -->
<div class="section">
  <!-- container -->
  <div class="container">
    <!-- row -->
				<div class="row">

       <!-- Product thumb imgs -->
      <div class="col-md-2  col-md-pull-5">

        <ng-template [ngIf]="thumbimages.length > 0">
          <div id="product-imgs">
            <div *ngFor="let t of thumbimages" class="product-preview">
              <img [src]="imageBaseUrl + t" alt="">
            </div>
          </div>
        </ng-template>
        <ng-template [ngIf]="product.length > 0">
          <div id="product-imgs">
            <div class="product-preview">
              <img [src]="imageBaseUrl + product.image" alt="">
            </div>
          </div>
        </ng-template>

      </div>
      <!-- /Product thumb imgs -->

      <!-- Product main img -->
      <div class="col-md-5 col-md-push-2">
        <div id="product-main-img">

          <ng-template [ngIf]="product.length > 0">
            <div class="product-preview">
              <img [src]="imageBaseUrl + product.image" alt="">
            </div>
          </ng-template>
          <ng-template [ngIf]="thumbimages.length > 0">
            <div class="product-preview" *ngFor="let t of thumbimages">
              <img [src]="imageBaseUrl + t" alt="">
            </div>
          </ng-template>


        </div>
      </div>
      <!-- /Product main img -->

					<!-- Product details -->
          <div class="col-md-5">
            <div class="product-details">
              <h2 class="product-name">{{product?.name}}</h2>
              <div>
                <div class="product-rating">
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star"></i>
                  <i class="fa fa-star-o"></i>
                </div>
                <a class="review-link" href="#">10 Review(s) | Add your review</a>
              </div>
              <div>
                <h3 class="product-price">{{product?.price | currency:'INR'}}</h3>
                <ng-template [ngIf]="product.quantity > 0">
                  <span class="product-available">In Stock</span>
                </ng-template>
                <ng-template [ngIf]="product.quantity === 0">
                  <span class="product-available">No Longer in Stock</span>
                </ng-template>
              </div>
              <p>{{product?.description}}</p>
          
          
              <ng-template [ngIf]="product.quantity > 0">
                <div class="add-to-cart">
                  <div class="qty-label">
                    Quantity
                    <div class="input-number">
                      <input #quantity [max]="product?.quantity" [min]="product?.quantity >= 1 ? product?.quantity : 1" readonly
                        type="number" value="{{product?.quantity >= 1 ? 1 : 0}}">
                      <span (click)="Increase()" class="qty-up">+</span>
                      <span (click)="Decrease()" class="qty-down">-</span>
                    </div>
                  </div>
                  <button  *ngIf="product?.quantity >= 1" class="btn btn-outline-primary btn-sm btn-block" (click)="AddToCart(product?.id)"><i
                      class="fa fa-shopping-cart"></i>Add To Cart
                  </button>
                </div>
              </ng-template>
          
          
          
              <ul class="product-links">
                <li>Category:</li>
                <li>{{product.category}}</li>
              </ul>
          
              <ul class="product-links">
                <li>Share:</li>
                <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
                <li><a href="#"><i class="fa fa-envelope"></i></a></li>
              </ul>
          
            </div>
          </div>
					<!-- /Product details -->

					<!-- Product tab -->
					<div class="col-md-12">
						<div id="product-tab">
							<!-- product tab nav -->
							<ul class="tab-nav">
								<li class="active"><a data-toggle="tab" href="#tab1">Description</a></li>
								<li><a data-toggle="tab" href="#tab2">Details</a></li>
								<li><a data-toggle="tab" href="#tab3">Reviews (3)</a></li>
							</ul>
							<!-- /product tab nav -->

							<!-- product tab content -->
							<div class="tab-content">
								<!-- tab1  -->
								<div id="tab1" class="tab-pane fade show active">
									<div class="row">
										<div class="col-md-12">
											<p>{{product?.description}}</p>
										</div>
									</div>
								</div>
								<!-- /tab1  -->

								<!-- tab2  -->
								<div id="tab2" class="tab-pane fade show">
									<div class="row">
										<div class="col-md-12">
											<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
										</div>
									</div>
								</div>
								<!-- /tab2  -->

								<!-- tab3  -->
								<div id="tab3" class="tab-pane fade show">
									<div class="row"> 
										<!-- Rating -->
									<div class="col-md-3">
											<div id="rating">
												<div class="rating-avg">
													<span>4.5</span>
													<div class="rating-stars">
														<i class="fa fa-star"></i>
														<i class="fa fa-star"></i>
														<i class="fa fa-star"></i>
														<i class="fa fa-star"></i>
														<i class="fa fa-star-o"></i>
													</div>
												</div>
												<ul class="rating">
													<li>
														<div class="rating-stars">
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
														</div>
														<div class="rating-progress">
															<div style="width: 80%;"></div>
														</div>
														<span class="sum">3</span>
													</li>
													<li>
														<div class="rating-stars">
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
															<i class="fa fa-star-o"></i>
														</div>
														<div class="rating-progress">
															<div style="width: 60%;"></div>
														</div>
														<span class="sum">2</span>
													</li>
													<li>
														<div class="rating-stars">
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
															<i class="fa fa-star-o"></i>
															<i class="fa fa-star-o"></i>
														</div>
														<div class="rating-progress">
															<div></div>
														</div>
														<span class="sum">0</span>
													</li>
													<li>
														<div class="rating-stars">
															<i class="fa fa-star"></i>
															<i class="fa fa-star"></i>
															<i class="fa fa-star-o"></i>
															<i class="fa fa-star-o"></i>
															<i class="fa fa-star-o"></i>
														</div>
														<div class="rating-progress">
															<div></div>
														</div>
														<span class="sum">0</span>
													</li>
													<li>
														<div class="rating-stars">
															<i class="fa fa-star"></i>
															<i class="fa fa-star-o"></i>
															<i class="fa fa-star-o"></i>
															<i class="fa fa-star-o"></i>
															<i class="fa fa-star-o"></i>
														</div>
														<div class="rating-progress">
															<div></div>
														</div>
														<span class="sum">0</span>
													</li>
												</ul>
											</div>
										</div> 
										<!-- /Rating -->

										<!-- Reviews -->
										<div class="col-md-6">
											<div id="reviews">
												<ul class="reviews">
													<li>
														<div class="review-heading">
															<h5 class="name">John</h5>
															<p class="date">27 DEC 2018, 8:0 PM</p>
															<div class="review-rating">
																<i class="fa fa-star"></i>
																<i class="fa fa-star"></i>
																<i class="fa fa-star"></i>
																<i class="fa fa-star"></i>
																<i class="fa fa-star-o empty"></i>
															</div>
														</div>
														<div class="review-body">
															<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>
														</div>
													</li>
													<li>
														<div class="review-heading">
															<h5 class="name">John</h5>
															<p class="date">27 DEC 2018, 8:0 PM</p>
															<div class="review-rating">
																<i class="fa fa-star"></i>
																<i class="fa fa-star"></i>
																<i class="fa fa-star"></i>
																<i class="fa fa-star"></i>
																<i class="fa fa-star-o empty"></i>
															</div>
														</div>
														<div class="review-body">
															<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>
														</div>
													</li>
													<li>
														<div class="review-heading">
															<h5 class="name">John</h5>
															<p class="date">27 DEC 2018, 8:0 PM</p>
															<div class="review-rating">
																<i class="fa fa-star"></i>
																<i class="fa fa-star"></i>
																<i class="fa fa-star"></i>
																<i class="fa fa-star"></i>
																<i class="fa fa-star-o empty"></i>
															</div>
														</div>
														<div class="review-body">
															<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>
														</div>
													</li>
												</ul>
												<ul class="reviews-pagination">
													<li class="active">1</li>
													<li><a href="#">2</a></li>
													<li><a href="#">3</a></li>
													<li><a href="#">4</a></li>
													<li><a href="#"><i class="fa fa-angle-right"></i></a></li>
												</ul>
											</div>
										</div> 
										<!-- /Reviews -->

										<!-- Review Form -->
									<div class="col-md-3">
											<div id="review-form">
												<form class="review-form">
													<input class="input" type="text" placeholder="Your Name">
													<input class="input" type="email" placeholder="Your Email">
													<textarea class="input" placeholder="Your Review"></textarea>
													<div class="input-rating">
														<span>Your Rating: </span>
														<div class="stars">
															<input id="star5" name="rating" value="5" type="radio"><label for="star5"></label>
															<input id="star4" name="rating" value="4" type="radio"><label for="star4"></label>
															<input id="star3" name="rating" value="3" type="radio"><label for="star3"></label>
															<input id="star2" name="rating" value="2" type="radio"><label for="star2"></label>
															<input id="star1" name="rating" value="1" type="radio"><label for="star1"></label>
														</div>
													</div>
													<button class="primary-btn">Submit</button>
												</form>
											</div>
										</div> 
										<!-- /Review Form -->
									</div>
								</div> 
								<!-- /tab3  -->
							</div>
							<!-- /product tab content  -->
						</div>
					</div>
					<!-- /product tab -->
				</div>
				<!-- /row -->
   
  </div>
  <!-- /container -->
</div>
<!-- /SECTION -->


<!-- Section -->
		<div class="section">
			<!-- container -->
			<div class="container">
				<!-- row -->
				<div class="row">

					<div class="col-md-12">
						<div class="section-title text-center">
							<h3 class="title">Related Products</h3>
						</div>
					</div>

					<!-- product -->
					<div class="col-md-3 col-xs-6"  *ngFor="let p of products" style="cursor: pointer;"
                (click)="selectProduct(getSlug(p.name + ' ' + p.id))">
						<div class="product">
							<div class="product-img">
								 <img [src]="imageBaseUrl + p.image" alt="{{p.name}}" width="200px" class="card-img-top" >
								<div class="product-label">
									<span class="sale">-30%</span>
								</div>
							</div>
							<div class="product-body">
								<p class="product-category">{{product.category}}</p>
								<h3 class="product-name"><a [routerLink]="['/product/' , getSlug(p.name + ' ' + p.id)]">{{p.name.substr(0, 30)  | titlecase}} ...</a></h3>
								<h4 class="product-price">{{p?.price | currency:'INR'}} <del class="product-old-price">{{p?.product_psp_price | currency:'INR'}}</del></h4>
								<div class="product-rating">
								</div>
								<div class="product-btns">
									<button class="add-to-wishlist"><i class="fa fa-heart"></i><span class="tooltipp">add to wishlist</span></button>
									<!-- <button class="add-to-compare"><i class="fa fa-exchange"></i><span class="tooltipp">add to compare</span></button> -->
									<button class="quick-view"><i class="fa fa-eye"></i><span class="tooltipp">quick view</span></button>
								</div>
							</div>
							<div class="add-to-cart">
								<button class="add-to-cart-btn" [class.disabled]="p.quantity < 1"
                    [class.btn-outline-danger]="p.quantity < 1" (click)="AddToCart(p.id)"><i class="fa fa-shopping-cart"></i>
                    {{
                    p.quantity < 1 ? "SOLD OUT" : "Add to Cart" }}</button>
							</div>
						</div>
					</div>
					<!-- /product -->

					

					<div class="clearfix visible-sm visible-xs"></div>

					

				</div>
				<!-- /row -->
			</div>
			<!-- /container -->
		</div>
		<!-- /Section -->

    <!-- NEWSLETTER -->
		<!-- <div id="newsletter" class="section">
		
			<div class="container">
			
				<div class="row">
					<div class="col-md-12">
						<div class="newsletter">
							<p>Sign Up for the <strong>NEWSLETTER</strong></p>
							<form>
								<input class="input" type="email" placeholder="Enter Your Email">
								<button class="newsletter-btn"><i class="fa fa-envelope"></i> Subscribe</button>
							</form>
							<ul class="newsletter-follow">
								<li>
									<a href="#"><i class="fa fa-facebook"></i></a>
								</li>
								<li>
									<a href="#"><i class="fa fa-twitter"></i></a>
								</li>
								<li>
									<a href="#"><i class="fa fa-instagram"></i></a>
								</li>
								<li>
									<a href="#"><i class="fa fa-pinterest"></i></a>
								</li>
							</ul>
						</div>
					</div>
				</div>
				
			</div>
			
		</div> -->
		<!-- /NEWSLETTER -->

    
